import type { EditorTab } from "@ncoder/code-editor";
import type { OpenFile } from "./types";
import { getMonacoLanguage } from "./monacoLanguage";

type VirtualFileMap = Record<
  string,
  { content: string; metadataType: string; name: string }
>;

export function buildPackageTabs(params: {
  openFiles: OpenFile[];
  activeFileId: string | null;
  viewingMain: boolean;
  contentByFileId: Record<string, string>;
  dirtyByFileId: Record<string, boolean>;
  originalByFileId: Record<string, string>;
  initialContent?: Record<string, string>;
  virtualFiles: VirtualFileMap;
}): EditorTab[] {
  const {
    openFiles,
    activeFileId,
    viewingMain,
    contentByFileId,
    dirtyByFileId,
    originalByFileId,
    initialContent,
    virtualFiles,
  } = params;

  return openFiles.map((f) => {
    const isActive = f.id === activeFileId;
    const showMain = isActive && viewingMain;
    return {
      id: f.id,
      label: f.name,
      language: getMonacoLanguage(f.name, f.metadataType),
      fileName: f.name,
      value: showMain
        ? (originalByFileId[f.id] ?? contentByFileId[f.id] ?? "")
        : (contentByFileId[f.id] ?? ""),
      isDirty: showMain
        ? false
        : (dirtyByFileId[f.id] ??
            !!(initialContent?.[f.id] || virtualFiles[f.id])),
      meta: { metadataType: f.metadataType },
    };
  });
}
